import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#A7A7B1",
      "fill-rule": "evenodd",
      d: "M14.902 7.82a5.902 5.902 0 1 1-11.804 0 5.902 5.902 0 0 1 11.804 0M9 12.498c.881 0 1.596-.233 1.596-.521S9.88 11.456 9 11.456s-1.596.233-1.596.52c0 .289.715.522 1.596.522",
      "clip-rule": "evenodd",
      style: {"fill":"color(display-p3 .6543 .6543 .6951)","fill-opacity":"1"}
    }, null, -1),
    _createElementVNode("path", {
      fill: "#6E6E7D",
      stroke: "#6E6E7D",
      "stroke-linecap": "round",
      "stroke-width": ".281",
      d: "m6.113 14.676-.092-.04-.068.074c-.09.1-.19.183-.292.251l.077.114-.077-.114-.06.04-.065.029h0a.46.46 0 0 0-.244.265c-.1.27.042.543.255.627.952.378 2.155.6 3.453.6s2.502-.222 3.453-.6a.49.49 0 0 0 .255-.627.46.46 0 0 0-.244-.265l-.066-.028-.059-.04a1.6 1.6 0 0 1-.291-.252l-.068-.075-.093.041A7.2 7.2 0 0 1 9 15.282c-1.025 0-2-.216-2.887-.606Z",
      style: {"fill":"color(display-p3 .4296 .4296 .4915)","fill-opacity":"1","stroke":"color(display-p3 .4296 .4296 .4915)","stroke-opacity":"1"}
    }, null, -1)
  ])))
}
export default { render: render }